export default __webpack_public_path__ + "static/media/tvazteca.a1610453.png";